var _circle, _circle2, _rect, _path, _path2, _path3, _circle3, _circle4, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDesignConfirmation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 135,
    viewBox: "0 0 135 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 67.5,
    cy: 67.5,
    r: 66.8351,
    fill: "white",
    stroke: "white",
    strokeWidth: 1.32979
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.75,
    cy: 67.5,
    r: 61.8351,
    fill: "#F2F9F1",
    stroke: "#82C275",
    strokeWidth: 1.32979
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 42.4844,
    y: 61.5161,
    width: 49.2021,
    height: 35.9043,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.0588 61.5161H42.4844V97.4204H91.6865V61.5161H83.0429",
    stroke: "#82C275",
    strokeWidth: 2.22074
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7031 39.6657C88.1899 38.5909 89.4559 38.1142 90.5307 38.6011C91.6056 39.0879 92.0822 40.3538 91.5954 41.4287L89.533 45.9821L77.9698 71.5118C77.8428 71.7922 77.6716 72.0504 77.4628 72.2767L73.6219 76.4378C73.5717 76.4922 73.5321 76.5051 73.505 76.5098C73.4696 76.5159 73.4212 76.512 73.3701 76.4889C73.319 76.4657 73.2842 76.4319 73.2654 76.4013C73.251 76.3778 73.2347 76.3395 73.2424 76.2659L73.8369 70.6344C73.8693 70.3282 73.9505 70.0292 74.0775 69.7488L85.6407 44.2191L87.7031 39.6657Z",
    fill: "white",
    stroke: "#82C275",
    strokeWidth: 2.22074
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5 70L74.5 66.5L75.06 66.724L88.5 38.5L91.5 39.5L81.5 64.5L79.5 68.5L75.06 66.724L73.5 70Z",
    fill: "#82C275"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.4556,
    cy: 91.4483,
    r: 1.39311,
    fill: "#82C275"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.0298,
    cy: 91.4483,
    r: 1.39311,
    fill: "#82C275"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4332 80.2354H56.497C53.428 80.2354 53.4281 85.7591 56.497 85.7591H81.0469C83.5018 85.7591 84.7293 86.9866 84.7293 88.8278C84.7293 90.6691 83.5019 91.8966 81.0469 91.8966C78.5919 91.8966 67.3399 91.8966 62.0207 91.8966",
    stroke: "#82C275",
    strokeWidth: 2.22074
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignConfirmation);
export default __webpack_public_path__ + "static/media/DesignConfirmation.15ddf1835e12e6d593c52cea4c24de09.svg";
export { ForwardRef as ReactComponent };